<!--  -->
<template>
  <div class="e_switch">
    <span>{{ $t(label) }}</span>
    <!-- {{switchBool}} -->
    <el-switch v-model="switchBool" :class="type" :disabled="disabled" @change="schange" />
  </div>
</template>

<script>
export default {
  name: 'ESwitch',
  model: {
    prop: 'value',
    event: 'change'
  },
  props: {
    value: {
      default: 0
    },
    options: {
      default() {
        return [{ value: 0, label: 'deviceDetail.Off' }, { value: 1, label: 'deviceDetail.On' }]
      }
    },
    type: {
      // default: 'tabbox'   // 开关不改变样式
      default: 'switchbox'
    },
    disabled: {
      // default: 'tabbox'   // 开关不改变样式
      default: false
    }
  },
  data() {
    return {
      switchBool: false
    }
  },
  computed: {
    label() {
      const i = this.switchBool ? 1 : 0
      return this.options[i].label
    }
  },
  watch: {
    value(val) {
      // console.log(val)
      this.switchBool = val == this.options[1].value
    }
  },
  mounted() {
    this.switchBool = this.value == this.options[1].value
  },
  methods: {
    schange(val) {
      const i = val ? 1 : 0
      this.$emit('change', this.options[i].value)
    }
  }
}
</script>

<style lang='scss' scoped>
.e_switch{
  display: flex;
  align-items: center;
  justify-content: flex-end;
  &>span{
    margin-right:5px;
  }
}
</style>
